/* Cobra Coldres — auto-hide do botão flutuante de WhatsApp.
   A barra "Comprar" é permanente no rodapé (mobile), então o botão vive acima dela
   (bottom 8.6rem) e acabava caindo sobre o preço. Aqui ele RECOLHE ao rolar para baixo
   (quando o cliente lê o preço/descrição) e VOLTA ao rolar para cima ou no topo — nunca
   fica parado em cima do preço. Só CSS class toggle; transição em cobra-whatsapp.css. */
(function () {
  var el = document.querySelector('.wa-float');
  if (!el) return;
  var lastY = window.pageYOffset || 0;
  var DELTA = 6; // ignora microtremores de scroll
  var ticking = false;

  function update() {
    var y = window.pageYOffset || 0;
    if (y < 80) {
      el.classList.remove('wa-float--hide');        // topo: sempre visível
    } else if (y > lastY + DELTA) {
      el.classList.add('wa-float--hide');           // rolando para baixo: recolhe
    } else if (y < lastY - DELTA) {
      el.classList.remove('wa-float--hide');         // rolando para cima: volta
    }
    lastY = y;
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
})();
